import React from "react";
import { CircleLoading } from "../../assets/icons/icons";

const BtnLoad = () => {
  return (
    <div className="loading-button">
      <CircleLoading />
    </div>
  );
};

export default BtnLoad;
